import React, { useEffect, useState, useCallback, useContext } from "react";
import Firebase from "firebase";
import {
	Spin,
	Typography,
	Button,
	message,
	Alert,
	Progress,
	Card,
	Rate,
} from "antd";
import { CheckCircleTwoTone } from "@ant-design/icons";
import moment from "moment";
import { AuthContext } from "./Auth.js";
import "antd/dist/antd.css";
import Carousel from "nuka-carousel";
import app from "./base";
import queryString from "query-string";
import { withRouter } from "react-router";
import Header from "./survey/Header";
import Footer from "./survey/Footer";
import { View, Text, Image } from "react-native-web";
import Chart from "./live/Chart/Chart";
import logo from "./logo.png";

const { Title } = Typography;
const CryptoJS = require("crypto-js");
const dbRef = Firebase.database().ref();

function getWindowDimensions() {
	const { innerWidth: width, innerHeight: height } = window;
	return {
		width,
		height,
	};
}

const Home = (props) => {
	const [post, setCurrentPost] = useState(null);
	const [userSelectedIndex, setUserSelectedIndex] = useState(-1);
	const [isLive, setLive] = useState(null);
	const [isPollExists, setPollExists] = useState(true);
	const [isLoading, setLoading] = useState(true);
	const [isWIP, setWIP] = useState(false);
	const [params, setParams] = useState(null);
	const [voted, setVoted] = useState(false);
	const [alreadyVoted, setalreadyVoted] = useState(false);
	const [ratingValue, setRatingValue] = useState(-1);
	const [averageValue, setAverageValue] = useState(-1);
	const { currentUser } = useContext(AuthContext);
	const [windowDimensions, setWindowDimensions] = useState(
		getWindowDimensions()
	);
	const [slideIndex, setslideIndex] = useState(0);
	const [validated, setValidated] = useState(true);
	const [notValid, setNotValid] = useState(false);
	const [passcode, setPasscode] = useState(-1);
	const [actualPasscode, setActualPasscode] = useState(-1);

	useEffect(() => {
		async function fetchPollData() {
			var suggestion = null;
			var expired = null;
			var poll = null;

			const params = queryString.parse(props.location.search);
			setParams(params);
			if (!params.key) {
				setPollExists(false);
			}

			if (params.p) {
				if (!params.u) {
					setLoading(false);
					setPollExists(false);
				}
				suggestion = await dbRef
					.child(`privatePolls/${params.u}/${params.key}`)
					.once("value");

				if (suggestion.exists()) {
					poll = suggestion.val();
					setLive(moment().isBefore(poll.enddate));
				} else {
					setPollExists(false);
				}
			} else {
				suggestion = await dbRef
					.child(`suggestions/${params.key}`)
					.once("value");

				if (suggestion.exists()) {
					poll = suggestion.val();
					setLive(true);
				} else {
					expired = await dbRef.child(`expired/${params.key}`).once("value");
					if (expired.exists()) {
						poll = expired.val();
						setLive(false);
					} else {
						setPollExists(false);
					}
				}
			}

			// if (poll && !poll.options) {
			// 	setWIP(true);
			// } else {
			setCurrentPost(poll);
			const defaultIndex =
				poll && poll.userVotes && poll.userVotes[currentUser.uid] > -1
					? poll.userVotes[currentUser.uid]
					: -1;
			setUserSelectedIndex(defaultIndex);
			setRatingValue(defaultIndex + 1);
			setalreadyVoted(defaultIndex !== -1 ? true : false);

			if (poll && poll.isRating) {
				const values = Object.values(poll.votesPerOption).slice(0, 5);
				var count = 0;
				var sum = values.reduce(function (sum, item, index) {
					count += item;
					return sum + item * (index + 1);
				}, 0);

				setAverageValue(count > 0 ? Math.round((sum / count) * 10) / 10 : 0);
			}

			if (poll.secure) {
				setValidated(false);
				setActualPasscode(
					CryptoJS.enc.Base64.parse(poll.passcode).toString(CryptoJS.enc.Utf8)
				);
			}

			//}

			setLoading(false);
		}
		fetchPollData();
	}, [currentUser, props]);

	const onVote = useCallback(
		async (index) => {
			try {
				console.log(userSelectedIndex);
				if (userSelectedIndex !== -1 && !post.changeVote) {
					message.error("Vote change is not allowed for this poll");
					return;
				}

				message.success("Response is recorded");
				const table = params.p
					? `privatePolls/${params.u}/${post.key}`
					: `suggestions/${post.key}`;
				try {
					const suggestion = await dbRef.child(`${table}`).once("value");
					if (!suggestion.exists()) {
						return;
					}

					setVoted(true);

					var votes = suggestion.val().userVotes;
					var votesPerOption = suggestion.val().votesPerOption;
					var totalVotes = suggestion.val().totalVotes;

					const previousIndex = votes && votes[currentUser.uid];
					if (previousIndex > -1) {
						votesPerOption[previousIndex] = votesPerOption[previousIndex] - 1;
						votesPerOption[index] = votesPerOption[index] + 1;
					} else {
						votesPerOption[index] = votesPerOption[index] + 1;
						totalVotes = totalVotes + 1;
					}

					if (previousIndex > -1) {
						//remove picture from here
						dbRef
							.child(`votes/${post.key}/${previousIndex}/${currentUser.uid}`)
							.remove();
						dbRef
							.child(
								`${table}/voterPictures/${previousIndex}/${currentUser.uid}`
							)
							.remove();
					} else {
						dbRef
							.child(`users/${currentUser.uid}/voteCount`)
							.transaction(function (vote) {
								return (vote || 0) + 1;
							});
					}

					var updateComment = {};
					updateComment[`${table}/userVotes/${currentUser.uid}`] = index;
					updateComment[`${table}/votesPerOption`] = votesPerOption;
					updateComment[`${table}/totalVotes`] = totalVotes;

					updateComment[
						`votes/${post.key}/${index}/${currentUser.uid}/userid`
					] = currentUser.uid;
					updateComment[`votes/${post.key}/${index}/${currentUser.uid}/name`] =
						currentUser.displayName;
					updateComment[
						`votes/${post.key}/${index}/${currentUser.uid}/picture`
					] = currentUser.photoURL;
					updateComment[
						`votes/${post.key}/${index}/${currentUser.uid}/creationDate`
					] = new Date();
					updateComment[
						`votes/${post.key}/${index}/${currentUser.uid}/ownerid`
					] = post.userid;
					updateComment[`votesByUser/${currentUser.uid}/${post.key}`] = index;
					updateComment[`${table}/voterPictures/${index}/${currentUser.uid}`] =
						currentUser.photoURL;
					dbRef.update(updateComment);
				} catch (err) {
					console.log(err);
				}
				setUserSelectedIndex(index);
			} catch (error) {
				alert(error);
			}
		},
		[currentUser, post, params, userSelectedIndex]
	);

	if (isLoading) {
		return (
			<div
				style={{
					alignItems: "center",
					justifyContent: "center",
					textAlign: "center",
					height: "100vh",
				}}
			>
				<Spin style={{ marginTop: 20 }} size="large" />
			</div>
		);
	}

	if (!isPollExists) {
		return (
			<div
				style={{
					alignItems: "center",
					justifyContent: "center",
					display: "flex",
				}}
			>
				<div>
					<Alert
						style={{ width: 350, height: 80, marginTop: 20 }}
						message="Poll not found!"
						description="Please check with creator if poll is still live"
						type="error"
						showIcon
					/>
					<div style={{ textAlign: "center" }}>
						<Button
							style={{ marginTop: 20, borderRadius: 20 }}
							onClick={() => app.auth().signOut()}
						>
							Sign out
						</Button>
					</div>
				</div>
			</div>
		);
	}

	if (isWIP) {
		return (
			<div className="center">
				<div className="site-card-border-less-wrapper">
					<Card
						hoverable
						style={{
							width: 400,
							alignItems: "center",
							justifyContent: "center",
							marginTop: 20,
						}}
					>
						<img
							alt="hello"
							src={require("./images/under.png")}
							style={{
								width: 100,
								height: 100,
								borderRadius: 5,
								alignSelf: "center",
							}}
						/>

						<div>
							<Title level={4} style={{ marginTop: 20 }}>
								Apologies, image based polls or questions are not supported in
								Suggestify for web
							</Title>
							<Text>Stay tuned, We are hard at work to add those</Text>
						</div>

						<Button
							style={{ marginTop: 20, borderRadius: 20 }}
							onClick={() => app.auth().signOut()}
						>
							Sign out
						</Button>
					</Card>
				</div>
			</div>
		);
	}

	if (!validated) {
		return (
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100vh",
				}}
			>
				<View style={{ alignItems: "center" }}>
					<Image
						source={logo}
						style={{
							height: 70,
							width: 70,
							borderRadius: 10,
							marginBottom: 30,
						}}
					/>

					<View
						style={{
							height: 60,
							alignItems: "center",
						}}
					>
						<input
							style={{
								fontSize: 18,
								textAlign: "center",
								fontFamily: "NunitoSans",
								fontWeight: "500",
								height: 40,
							}}
							maxLength="5"
							onChange={(e) => setPasscode(e.target.value)}
							placeholder="Enter passcode"
						/>
						{notValid && (
							<Text
								style={{
									height: 20,
									color: "red",
									fontFamily: "NunitoSans",
									fontWeight: "500",
								}}
							>
								Incorrect passcode
							</Text>
						)}
					</View>

					<Button
						type="primary"
						style={{
							borderRadius: 25,
							marginTop: 30,
							height: 40,
							width: 100,
							fontSize: 16,
							fontWeight: "600",
							backgroundColor: "#196BFF",
						}}
						onClick={() => {
							setNotValid(passcode !== actualPasscode);
							setValidated(passcode == actualPasscode);
						}}
					>
						Enter
					</Button>
				</View>
			</div>
		);
	}

	var human = null;
	human = `${post.totalVotes} Votes`;

	return (
		<View>
			<Header />

			<div
				style={{
					display: "flex",
					justifyContent: "center",
					height: "80vh",
				}}
			>
				<View
					style={{
						flex: 1,
						padding: 20,
					}}
				>
					{/* {post.referenceImage && (
						<Image
							source={{ uri: post.referenceImage }}
							style={{
								width: 500,
								height: 200,
								marginBottom: 30,
								alignSelf: "center",
							}}
						/>
					)} */}

					{/* Header */}
					<Text
						style={{
							marginTop: 20,
							fontSize: 20,
							fontWeight: "600",
							textAlign: "center",
							width: "100%",
							fontFamily: "NunitoSans",
						}}
					>
						{post.question}
					</Text>

					<Text
						style={{
							marginTop: 10,
							textAlign: "center",
							fontFamily: "NunitoSans",
						}}
					>
						{post.anonymous ? "Anonymous" : post.username || "Suggestify user"}
						{" :"} {human}
					</Text>

					{/* Hashtags */}
					{post.hashtags && (
						<Text
							style={{
								fontSize: 12,
								color: "#418FEA",
								textAlign: "center",
								marginTop: 10,
								fontFamily: "NunitoSans",
							}}
						>
							{post.hashtags}
						</Text>
					)}

					{isLive &&
						post.options &&
						post.options.map((item, i) => (
							<Button
								disabled={!isLive}
								style={{
									borderRadius: 20,
									marginTop: i == 0 ? 30 : 20,
									height: 40,
									width: "100%",
									fontSize: 16,
									fontWeight: "600",
									fontFamily: "NunitoSans",
									backgroundColor:
										userSelectedIndex === i ? post.colors[i] : "#eeeeee",
									borderColor: userSelectedIndex === i ? post.colors[i] : null,
									borderWidth: userSelectedIndex === i ? 2 : null,
									color:
										userSelectedIndex === i ? "#000" : isLive ? null : "#000",
								}}
								onClick={() => onVote(i)}
							>
								{post.options[i]}
							</Button>
						))}

					{!isLive &&
						post.options &&
						post.options.map((item, i) => (
							<View style={{ marginTop: i == 0 ? 30 : 10 }}>
								<Text style={{ fontSize: 18, fontWeight: "500" }}>
									{post.options[i]}
								</Text>
								<Progress
									percent={Math.round(
										(post.votesPerOption[i] / post.totalVotes) * 100
									)}
									strokeColor={post.colors[i]}
									style={{ height: 20 }}
								/>

								<View style={{ alignItems: "flex-end" }}>
									<Text style={{ fontSize: 12, fontFamily: "NunitoSans" }}>
										{post.votesPerOption[i]} {" votes"}
									</Text>
								</View>
							</View>
						))}

					{/* {isLive && post.isRating && (
						<View style={{ marginTop: 50, alignItems: 'center', }}>
							<Rate
								allowClear={false}
								style={{ fontSize: 45 }}
								defaultValue={userSelectedIndex + 1}
								value={ratingValue}
								onChange={(val) => {
									setRatingValue(val);
									onVote(val - 1);
								}}
							/>
						</View>
					)} */}

					{isLive && post.isRating && (
						<View style={{ marginTop: 30, marginHorizontal: 30 }}>
							<View style={{ marginBottom: 20, alignItems: "center" }}>
								<Text
									style={{
										fontSize: 50,
										fontFamily: "NunitoSans",
										fontWeight: "bold",
									}}
								>
									{averageValue}
								</Text>
								<Text
									style={{
										fontFamily: "NunitoSans",
										fontWeight: "bold",
										color: "#9DA3B4",
									}}
								>
									{"Out of"} {5}
								</Text>

								<View style={{ marginTop: 10, alignItems: "center" }}>
									<Rate
										allowHalf
										style={{ fontSize: 45 }}
										defaultValue={3.5}
										value={averageValue}
										onChange={(val) => {
											setRatingValue(val);
											onVote(val - 1);
										}}
										disabled={true}
									/>
								</View>
							</View>
							{[...Array(5)].map((id, i) => (
								<View>
									<Rate
										disabled
										style={{ fontSize: 20 }}
										defaultValue={i + 1}
										value={i + 1}
									/>
									<Progress
										percent={Math.round(
											(post.votesPerOption[i] / post.totalVotes) * 100
										)}
										strokeColor={"gold"}
										style={{ height: 20 }}
									/>

									<View style={{ alignItems: "flex-end" }}>
										<Text
											style={{
												fontSize: 12,
												fontFamily: "NunitoSans",
												fontWeight: "bold",
											}}
										>
											{post.votesPerOption[i]} {" votes"}
										</Text>
									</View>
								</View>
							))}
						</View>
					)}

					{post.images && (
						<div style={{ marginTop: 20, backgroundColor: "#000" }}>
							<Carousel
								renderCenterLeftControls={false}
								renderCenterRightControls={false}
								afterSlide={(slideIndex) => setslideIndex(slideIndex)}
								renderBottomRightControls={({ nextSlide }) =>
									slideIndex === userSelectedIndex && (
										<div
											style={{
												backgroundColor: "rgba(0,0,0,0.8)",
												padding: 5,
											}}
										>
											<CheckCircleTwoTone twoToneColor="#52c41a" />
											<Text style={{ color: "white" }}> Your vote</Text>
										</div>
									)
								}
							>
								{post.images.map((item, i) => (
									<div>
										<img
											alt="hello"
											src={item}
											style={{
												width: 300,
												height: windowDimensions.height / 2,
											}}
										/>
									</div>
								))}
							</Carousel>
						</div>
					)}

					{post.options && (voted || alreadyVoted) && (
						<View style={{ marginTop: 20, alignItems: "center" }}>
							<Text
								style={{
									fontSize: 15,
									fontWeight: "500",
									color: "green",
									fontFamily: "NunitoSans",
								}}
							>
								{" "}
								Vote registered
							</Text>
						</View>
					)}

					{(post.options || post.isRating) && (
						<View style={{ alignItems: "center", marginTop: 40 }}>
							<Text
								style={{
									fontSize: 15,
									fontWeight: "500",
									fontFamily: "NunitoSans",
								}}
							>
								{isLive ? "Poll ends " : "Poll closed "}
								{moment(post.enddate).fromNow()}
							</Text>
							<Button
								type="primary"
								style={{
									borderRadius: 25,
									marginBottom: 20,
									marginLeft: 20,
									height: 40,
									width: 100,
									fontSize: 16,
									fontWeight: "600",
									marginTop: 20,
									backgroundColor: "#196BFF",
								}}
								onClick={() => app.auth().signOut()}
							>
								Sign out
							</Button>
						</View>
					)}

					{post.images && (
						<button
							class="load-button"
							disabled={slideIndex === userSelectedIndex}
							onClick={() => onVote(slideIndex)}
						>
							{slideIndex === userSelectedIndex ? "Voted" : "Vote"}
						</button>
					)}
				</View>
			</div>

			{/* <View style={{ alignItems: "center" }}></View>
			<Footer currentPost={post} /> */}
		</View>
	);
};

export default withRouter(Home);
